export const chartData = () => {
    return [
        {
            title: "courtside rows 1 & 2",
            titleRow: true,
            side: "left",
            sectionData: [
                {
                    hex: "#ff0000",
                    title: "super vip's row 1",
                    beforeFull: "75000",
                    beforeHalf: "43130",
                    afterFull: "82500",
                    afterHalf: "47440",
                    border: false
                },
                {
                    hex: "#f28e2b",
                    title: "row 1 center court",
                    beforeFull: "60000",
                    beforeHalf: "34500",
                    afterFull: "66000",
                    afterHalf: "37950",
                    border: true
                },
                {
                    hex: "#ffbe7d",
                    title: "row 1 sideline",
                    beforeFull: "56500",
                    beforeHalf: "32490",
                    afterFull: "62150",
                    afterHalf: "35740",
                    border: true
                },
                {
                    hex: "#4e79a7",
                    title: "row 1 baseline",
                    beforeFull: "50000",
                    beforeHalf: "28750",
                    afterFull: "55000",
                    afterHalf: "31620",
                    border: true
                },
                {
                    hex: "#1d42ba",
                    title: "super vip's row 2",
                    beforeFull: "45000",
                    beforeHalf: "25870",
                    afterFull: "49500",
                    afterHalf: "28460",
                    border: true
                },
            ]
        },
        {
            title: "courtside rows 2 & 3",
            titleRow: false,
            side: "left",
            sectionData: [
                {
                    hex: "#d77c69",
                    title: "row 2 center",
                    beforeFull: "22500",
                    beforeHalf: "12940",
                    afterFull: "24750",
                    afterHalf: "14230",
                    border: false
                },
                {
                    hex: "#d7b5a6",
                    title: "row 2 sideline",
                    beforeFull: "20000",
                    beforeHalf: "11500",
                    afterFull: "22000",
                    afterHalf: "12650",
                    border: true
                },
                {
                    hex: "#ffaa00",
                    title: "row 2 baseline",
                    beforeFull: "18000",
                    beforeHalf: "10350",
                    afterFull: "19800",
                    afterHalf: "11390",
                    border: true
                },
                {
                    hex: "#4e79a7",
                    title: "row 3 center",
                    beforeFull: "15000",
                    beforeHalf: "8630",
                    afterFull: "16500",
                    afterHalf: "9490",
                    border: true
                },
                {
                    hex: "#a0cbe8",
                    title: "row 3 sideline",
                    beforeFull: "14000",
                    beforeHalf: "8050",
                    afterFull: "15400",
                    afterHalf: "8860",
                    border: true
                },
                {
                    hex: "#550000",
                    title: "row 3 baseline",
                    beforeFull: "13000",
                    beforeHalf: "7470",
                    afterFull: "14300",
                    afterHalf: "8220",
                    border: true
                },
            ]
        },
        {
            title: "All-Inclusive: Players Club",
            titleRow: false,
            side: "left",
            sectionData: [
                {
                    hex: "#9f0000",
                    lines: true,
                    title: "players club rows 1-4",
                    beforeFull: "13500",
                    beforeHalf: "14850",
                    afterFull: "7760",
                    afterHalf: "8540",
                    border: false
                },
            ]
        },
        {
            title: "All-Inclusive: Rehmann Club",
            titleRow: false,
            side: "left",
            sectionData: [
                {
                    hex: "#006200",
                    lines: true,
                    title: "lower center court rows 5-9",
                    beforeFull: "10500",
                    beforeHalf: "6040",
                    afterFull: "11550",
                    afterHalf: "6640",
                    border: false
                },
                {
                    hex: "#00c300",
                    lines: true,
                    title: "lower center court rows 10+",
                    beforeFull: "10200",
                    beforeHalf: "6120",
                    afterFull: "11220",
                    afterHalf: "6730",
                    border: true
                },
                {
                    hex: "#35a3a3",
                    lines: true,
                    title: "lower center sideline rows 5-9",
                    beforeFull: "9590",
                    beforeHalf: "5510",
                    afterFull: "10550",
                    afterHalf: "6070",
                    border: true
                },
                {
                    hex: "#53ffff",
                    lines: true,
                    title: "lower center sideline rows 10+",
                    beforeFull: "9370",
                    beforeHalf: "5620",
                    afterFull: "10310",
                    afterHalf: "6190",
                    border: true
                },
            ]
        },
        {
            title: "All-Inclusive: MotorCity Casino Club",
            titleRow: false,
            side: "left",
            sectionData: [
                {
                    hex: "#37736f",
                    lines: true,
                    title: "lower center court rows 1-4",
                    beforeFull: "11620",
                    beforeHalf: "6680",
                    afterFull: "12780",
                    afterHalf: "7350",
                    border: false
                },
                {
                    hex: "#499894",
                    lines: true,
                    title: "lower center court rows 5-9",
                    beforeFull: "9900",
                    beforeHalf: "5690",
                    afterFull: "10890",
                    afterHalf: "6620",
                    border: true
                },
                {
                    hex: "#5abfb9",
                    lines: true,
                    title: "lower center court rows 10+",
                    beforeFull: "9440",
                    beforeHalf: "5660",
                    afterFull: "10380",
                    afterHalf: "6230",
                    border: true
                },
                {
                    hex: "#7f0000",
                    lines: true,
                    title: "lower center sideline rows 1-4",
                    beforeFull: "10690",
                    beforeHalf: "6150",
                    afterFull: "11760",
                    afterHalf: "6760",
                    border: true
                },
                {
                    hex: "#d60000",
                    lines: true,
                    title: "lower center sideline rows 5-9",
                    beforeFull: "9150",
                    beforeHalf: "5260",
                    afterFull: "10070",
                    afterHalf: "5790",
                    border: true
                },
                {
                    hex: "#ff2d03",
                    lines: true,
                    title: "lower center sideline rows 10+",
                    beforeFull: "8670",
                    beforeHalf: "5200",
                    afterFull: "9540",
                    afterHalf: "5720",
                    border: true
                },
            ]
        },
        {
            title: "All-Inclusive: Legends Club",
            titleRow: true,
            side: "right",
            sectionData: [
                {
                    hex: "#d4a6c8",
                    lines: true,
                    title: "legends club",
                    beforeFull: "7700",
                    beforeHalf: "4620",
                    afterFull: "8470",
                    afterHalf: "5080",
                    border: false
                },
            ]
        },
        {
            title: "100-level",
            titleRow: false,
            side: "right",
            sectionData: [
                {
                    hex: "#ff5500",
                    title: "lower center sideline rows 1-4",
                    beforeFull: "7410",
                    beforeHalf: "4450",
                    afterFull: "8150",
                    afterHalf: "4890",
                    border: false
                },
                {
                    hex: "#ff9b29",
                    title: "lower center sideline rows 5-9",
                    beforeFull: "6660",
                    beforeHalf: "4000",
                    afterFull: "7330",
                    afterHalf: "4400",
                    border: true
                },
                {
                    hex: "#ffc12e",
                    title: "lower center sideline rows 10+",
                    beforeFull: "5910",
                    beforeHalf: "3550",
                    afterFull: "6500",
                    afterHalf: "3900",
                    border: true
                },
                {
                    hex: "#00287e",
                    title: "lower semi corner/bookends rows 1-4",
                    beforeFull: "4600",
                    beforeHalf: "2760",
                    afterFull: "5060",
                    afterHalf: "3040",
                    border: true
                },
                {
                    hex: "#0055ff",
                    title: "lower semi corner/bookends rows 5-9",
                    beforeFull: "3720",
                    beforeHalf: "2230",
                    afterFull: "4090",
                    afterHalf: "2450",
                    border: true
                },
                {
                    hex: "#669ac5",
                    title: "lower semi corner/bookends rows 10+",
                    beforeFull: "2860",
                    beforeHalf: "1720",
                    afterFull: "3150",
                    afterHalf: "1890",
                    border: true
                },
                {
                    hex: "#98004c",
                    title: "lower corner rows 1-4",
                    beforeFull: "3300",
                    beforeHalf: "1980",
                    afterFull: "3630",
                    afterHalf: "2180",
                    border: true
                },
                {
                    hex: "#ff0080",
                    title: "lower corner rows 5-9",
                    beforeFull: "2640",
                    beforeHalf: "1580",
                    afterFull: "2900",
                    afterHalf: "1740",
                    border: true
                },
                {
                    hex: "#e182ab",
                    title: "lower corner rows 10+",
                    beforeFull: "2200",
                    beforeHalf: "1320",
                    afterFull: "2420",
                    afterHalf: "1450",
                    border: true
                },
                {
                    hex: "#2e5328",
                    title: "lower ends rows 1-4",
                    beforeFull: "1980",
                    beforeHalf: "1190",
                    afterFull: "2180",
                    afterHalf: "1310",
                    border: true
                },
                {
                    hex: "#5ba24e",
                    title: "lower ends rows 5-9",
                    beforeFull: "1760",
                    beforeHalf: "1060",
                    afterFull: "1940",
                    afterHalf: "1160",
                    border: true
                },
                {
                    hex: "#84be43",
                    title: "lower ends rows 10+",
                    beforeFull: "1160",
                    beforeHalf: "700",
                    afterFull: "1280",
                    afterHalf: "770",
                    border: true
                },
            ]
        },
        {
            title: "Mezzanine Level",
            titleRow: false,
            side: "right",
            sectionData: [
                {
                    hex: "#4e79a7",
                    title: "center",
                    beforeFull: "1760",
                    beforeHalf: "1060",
                    afterFull: "1940",
                    afterHalf: "1160",
                    border: false
                },
                {
                    hex: "#c16903",
                    title: "corner",
                    beforeFull: "1260",
                    beforeHalf: "760",
                    afterFull: "1390",
                    afterHalf: "830",
                    border: true
                },
                {
                    hex: "#4c4846",
                    title: "ends",
                    beforeFull: "990",
                    beforeHalf: "590",
                    afterFull: "1090",
                    afterHalf: "650",
                    border: true
                },
            ]
        },
    ]
}